import toast from 'react-hot-toast';
import { MODAL_TYPES, useGlobalModalContext } from 'context/GlobalModal';
import { strings } from 'strings';
import { Button } from 'shared/Components';
import { softDeletePuzzle } from 'services';
import { getActiveEventsPuzzlesParticipateIn } from 'services/utility/puzzles/events';
import { useCallback } from 'react';

export interface PuzzleProps {
  id: string;
  puzzle?: any;
  collectionId?: string;
  collectionIdFirebase?: string;
  collectionName?: string;
  keywords?: string;
  onCompleted?(): void;
}

export const DeletePuzzleButton = (props: PuzzleProps) => {
  const { id, onCompleted } = props;
  const { showModal, hideModal } = useGlobalModalContext();

  const dialogModal = () => {
    showModal(MODAL_TYPES.DIALOG_MODAL, {
      title: strings.deletePuzzle,
      text: strings.confirmDeletePuzzle,
      cancelButtonText: strings.cancel,
      submitButtonText: strings.deleteBtnPuzzle,
      onSubmit: () => deletePuzzle(),
    });
  };

  const deletePuzzle = useCallback(async () => {
    const activeEvents = await getActiveEventsPuzzlesParticipateIn(id);
    if (activeEvents?.length > 0) {
      const activeEventsString = activeEvents.map((event) => event.event.id).join(', ');
      toast.error(`Puzzle is currently in active events: ${activeEventsString}`);
      hideModal();
      return;
    }

    try {
      await softDeletePuzzle(id);
      toast.success(strings.puzzleDeletedSuccessfully);
      hideModal();
      onCompleted?.();
    } catch (error) {
      toast.error(strings.toastNotificationSomethingWrong);
    }
  }, [getActiveEventsPuzzlesParticipateIn, id, softDeletePuzzle, onCompleted]);

  return (
    <Button width={100} height={30} onClick={dialogModal} variant="danger">
      {strings.delete}
    </Button>
  );
};
